export const navBarItems = [
    {
        id: 1,
        name: "WhitePaper",
        link: "/whitepaper",
    },
    {
        id: 2,
        name: "Tokenomics",
        link: "/tokenomics",
    },
    {
        id: 3,
        name: "Logo",
        link: "/",
        logo: "/purge-logo.svg"
    },
    {
        id: 4,
        name: "Roadmap",
        link: "/roadmap",
    },
    {
        id: 5,
        name: "Contact",
        link: "/contact",
    },
]